export default __webpack_public_path__ + "img/03f02da4b3348abbc1b5b9739420865e.png";